export const nascarDataStateStore = {
  state: {
    currentToast: null,
    cardList: [],
    isAppMinimized: false,
    selectedMatch: {
      matchID: null,
      matchData: null,
      head2head: null,
      likelihood: null
    },
    playerColors: {
      player1: '#2478CC',
      player2: '#FFD400'
    },
    matches: [],
    isInteractionLocked: false,
  },
  getters: {
    currentToast: (state) => {
      return state.currentToast;
    },
    cardList: (state) => {
      return state.cardList;
    },
    isAppMinimized: (state) => {
      return state.isAppMinimized;
    },
    selectedMatch: (state) => {
      return state.selectedMatch;
    },
    playerColors: (state) => {
      return state.playerColors;
    },
    hasActiveMatch: (state) => {
      return state.selectedMatch.matchID != null;
    },
    matches: (state) => {
      return state.matches;
    },
    isInteractionLocked: (state) => {
      return state.isInteractionLocked;
    },
  },
  mutations: {
    currentToast(state, target) {
      state.currentToast = target
    },
    cardList(state, target) {
      state.cardList = target
    },
    pushCardList(state, target) {
      state.cardList.push(target)
    },
    isAppMinimized(state, target) {
      state.isAppMinimized = target
    },
    setMatch(state, target) {
      state.selectedMatch.matchData = target;
      state.selectedMatch.matchID = target.match_id;
    },
    head2head(state, target) {
      state.selectedMatch.head2head = target
    },
    likelihood(state, target) {
      state.selectedMatch.likelihood = target
    },
    backToMatchSelect(state, target) {
      state.selectedMatch.head2head = null;
      state.selectedMatch.matchData = null;
      state.selectedMatch.matchID = null;
      state.selectedMatch.likelihood = null;
    },
    matches(state, target) {
      state.matches = target
    },
    isInteractionLocked(state, target) {
      state.isInteractionLocked = target
    },
  }
};
